import keyBy from 'lodash/keyBy';
import { fromJS } from 'immutable';
import { ADD_ITEM_ANALYSES, ADD_QUIZ_ANALYSIS, QUIZ_ANALYSIS_NOT_FOUND, ITEM_ANALYSIS_NOT_FOUND, TOGGLE_ITEM_ANALYSIS_EXPANDED } from '@instructure/quiz-common';
var addItemAnalyses = function addItemAnalyses(state, itemAnalyses) {
  return state.setIn(['item_analysis'], fromJS(keyBy(itemAnalyses, 'itemId')));
};
var addQuizAnalysis = function addQuizAnalysis(state, quizAnalyses) {
  var quizAnalysis = quizAnalyses[0];
  return state.setIn(['quiz_analysis', quizAnalysis.quizId], fromJS(quizAnalysis));
};
var markQuizAnalysisNotFound = function markQuizAnalysisNotFound(state, quizId) {
  return state.setIn(['quiz_analysis', quizId], fromJS({
    quizId: quizId,
    notFound: true
  }));
};
var markItemAnalysisNotFound = function markItemAnalysisNotFound(state, itemId) {
  return state.setIn(['item_analysis', itemId], fromJS({
    itemId: itemId,
    notFound: true
  }));
};
var toggleItemAnalysisRow = function toggleItemAnalysisRow(state, itemId) {
  return state.updateIn(['item_analysis_row_open', itemId], false, function (isOpen) {
    return !isOpen;
  });
};
var defaultState = fromJS({});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ADD_ITEM_ANALYSES:
      return addItemAnalyses(state, action.payload);
    case ADD_QUIZ_ANALYSIS:
      return addQuizAnalysis(state, action.payload);
    case QUIZ_ANALYSIS_NOT_FOUND:
      return markQuizAnalysisNotFound(state, action.payload);
    case ITEM_ANALYSIS_NOT_FOUND:
      return markItemAnalysisNotFound(state, action.payload);
    case TOGGLE_ITEM_ANALYSIS_EXPANDED:
      return toggleItemAnalysisRow(state, action.payload);
    default:
      return state;
  }
});